<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0" :class="!valid && !loading ? 'ErrorBorder' : null">

      <v-container class="d-flex px-2 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="0" class="mr-4">
            <h3 v-text="IsNew ? 'New contact' : 'Edit contact'" class="useThemeTextColor" />
          </v-col>
        </v-row>
      </v-container>

      <v-form v-model="valid">
        <v-container class="px-4 pb-2 pt-0" v-if="editObject">
          <v-row no-gutters>
            <v-col cols="12">
              <QTextField v-model="editObject.Name" :label="$t('servicesystem.common_objects.contact.name')"
                :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editObject.Title" :label="$t('servicesystem.common_objects.contact.title')"
                externaledit>
              </QTextField>
            </v-col>
            <v-col cols="8" class="pr-3">
              <QTextField v-model="editObject.Email" :label="$t('servicesystem.common_objects.contact.email')"
                :rules="editObject.EmailAllowed ? [requiredRule, emailRule] : undefined" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="4">
              <QSwitchInput v-model="editObject.EmailAllowed"
                :label="$t('servicesystem.common_objects.contact.allow_email')" externaledit>
              </QSwitchInput>
            </v-col>
            <v-col cols="8" class="pr-3">
              <QTextField v-model="editObject.Mobile" :label="$t('servicesystem.common_objects.contact.mobile')"
                :rules="editObject.SmsAllowed ? [requiredRule, phoneRule] : undefined" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="4">
              <QSwitchInput v-model="editObject.SmsAllowed" :label="$t('servicesystem.common_objects.contact.allow_sms')"
                externaledit>
              </QSwitchInput>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editObject.FixedPhone" :label="$t('servicesystem.common_objects.contact.land_line')"
                externaledit>
                <!-- :rules="[phoneRule]" -->
              </QTextField>
            </v-col>
            <v-col cols="12" v-if="!IsNew">
              <QSwitchInput v-model="editObject.IsActive" :label="$t('servicesystem.common_objects.contact.active')"
                externaledit>
              </QSwitchInput>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="auto">
              <v-btn icon color="close" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col></v-col>
            <!--
            <v-col cols="auto"
                   v-if="!IsNew">
              <v-btn icon
                     :color="IsChanged ? 'tertiary' : 'disabled'"
                     @click="setEditObject()">
                <v-icon>mdi-undo-variant</v-icon>
              </v-btn>
            </v-col>
            -->
            <v-col></v-col>
            <v-col cols="auto">
              <v-btn icon :color="IsSaveable ? 'quaternary' : 'disabled'" @click="IsSaveable ? save() : null">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

    </v-card>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "ContactEdit",
  props: {
    CustomerId: [String, Number],
    Contact: Object,
  },
  components: {},
  mixins: [clientAPI],

  data: () => ({
    editObject: null,
    valid: false,
    loading: false,
  }),

  mounted() {
    this.setEditObject();
  },

  methods: {
    save() {
      this.loading = true;
      const methodname = this.IsNew ? "createCustomerContact" : "changeCustomerContactById";
      const emitname = this.IsNew ? "Created" : "Changed";
      const dto = Object.assign({}, this.editObject);
      this[methodname](dto)
        .then((response) => {
          response.MetaString =
            response.DisplayName +
            " " +
            response.Email +
            " " +
            response.Mobile +
            " " +
            response.FixedPhone +
            " " +
            response.Title;
          //console.log("Response", response);
          this.$emit(emitname, Object.assign({}, response));
        })
        .catch((response) => {
          console.error("getContacts error", response);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("Close");
        });
    },

    close() {
      this.$emit("Close");
    },

    setEditObject() {
      if (this.Contact && Object.keys(this.Contact).length) {
        this.editObject = Object.assign({}, this.Contact);
      } else {
        this.editObject = { CustomerId: this.CustomerId, FixedPhone: "", IsActive: true };
      }
    },
  },

  computed: {
    IsNew() {
      return !this.Contact || !this.Contact.Id;
    },

    IsChanged() {
      return !this.SameValue(this.Contact, this.editObject);
    },

    IsSaveable() {
      return this.valid && this.IsChanged;
    },
  },

  watch: {
    CustomerId: function () {
      this.setEditObject();
    },
    Contact: function () {
      this.setEditObject();
    },
  },
};
</script>


<style lang="scss" scoped>
.ErrorBorder {
  border: 1px solid var(--v-error-base);
}
</style>